import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IInProcessCollectionTransacitonsToolbar {
	onCreateDebitFileButtonClickedHandler: () => void
	onDeleteButtonClickedHandler: () => void
	onSaveButtonClickedHandler: () => void
	onUndoButtonClickedHandler: () => void
	onUploadedButtonClickedHandler: () => void
	onErrorInTransactionButtonClickedHandler: () => void
	onRollbackAfterCollectionButtonClickedHandler: () => void
}

export const InProcessCollectionTransacitonsToolbar: FC<IInProcessCollectionTransacitonsToolbar> = ({
	onCreateDebitFileButtonClickedHandler,
	onDeleteButtonClickedHandler,
	onSaveButtonClickedHandler,
	onUndoButtonClickedHandler,
	onUploadedButtonClickedHandler,
	onErrorInTransactionButtonClickedHandler,
	onRollbackAfterCollectionButtonClickedHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					label="Create Debit File"
					onClickHandler={onCreateDebitFileButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					label="Save"
					onClickHandler={onSaveButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Undo"
					raised
					onClickHandler={onUndoButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				<EnhancedButtonPrimeReact
					label="Uploaded"
					onClickHandler={onUploadedButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Error in Transaction"
					raised
					onClickHandler={onErrorInTransactionButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Rollback after Collection"
					raised
					onClickHandler={onRollbackAfterCollectionButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</Toolbar>
		</AppBar>
	);
};
